export function CertiCoreMark({ size = 40 }: { size?: number }) {
  const id = `ccg${size}`;
  const sh = `ccs${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={id} x1="2" y1="2" x2="38" y2="38" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="55%" stopColor="#0891b2" />
          <stop offset="100%" stopColor="#0c4a6e" />
        </linearGradient>
        <linearGradient id={sh} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
      </defs>

      {/* Background */}
      <rect width="40" height="40" rx="10" fill={`url(#${id})`} />
      {/* Subtle top-shine */}
      <rect width="40" height="20" rx="10" fill={`url(#${sh})`} />

      {/* Bold stylised C arc */}
      <path
        d="M27.5 14C25 11.2 21.7 9.5 18 9.5C11.1 9.5 5.5 15.1 5.5 22C5.5 28.9 11.1 34.5 18 34.5C21.7 34.5 25 32.8 27.5 30"
        stroke="white"
        strokeWidth="3.8"
        strokeLinecap="round"
        fill="none"
      />

      {/* Premium accent — small solid circle at the C opening */}
      <circle cx="29" cy="12" r="3.2" fill="white" />
      {/* Inner teal ring inside accent dot */}
      <circle cx="29" cy="12" r="1.4" fill="#0891b2" />
    </svg>
  );
}
